export default {"src":"/_next/static/media/google.88a88f1e.svg","height":21,"width":21,"blurWidth":0,"blurHeight":0};